import { useTheme } from '@celito.clients/theme';
import { createTestAttribute } from '@celito.clients/utils';
import Select, { GroupBase } from 'react-select';

import { Field } from '../../shared';
import { TextFieldSelectProps } from './text-field-select.model';
import classes from './text-field-select.styles.module.css';

interface TextFieldSelectViewProps<
  Option = unknown,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
> extends TextFieldSelectProps<Option, IsMulti, Group> {}

const TextFieldSelectView = <
  Option = unknown,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  dataTestId,
  label,
  required,
  errorMessage,
  styles,
  isClearable = true,
  ...props
}: TextFieldSelectViewProps<Option, IsMulti, Group>): JSX.Element => {
  const { theme } = useTheme();

  return (
    <div data-testid={dataTestId}>
      {label && (
        <Field
          data-testid={`${dataTestId}-${createTestAttribute(label)}`}
          className={classes.label}
          size="large"
          label={label}
          required={required}
        />
      )}
      <div data-testid={'input-field-select-fields'}>
        <Select
          styles={{
            ...styles,
            control: (baseStyles) => ({
              ...baseStyles,
              borderColor: errorMessage
                ? theme.colors.error_color
                : theme.colors.gray_400,
              minHeight: 40,
              ...styles?.control,
            }),
            menu: (baseStyles) => ({
              ...baseStyles,
              marginTop: 0,
              ...styles?.menu,
            }),
            placeholder: (baseStyles) => ({
              ...baseStyles,
              fontFamily: theme.fontFamily.regular,
              fontSize: '0.875rem',
              ...styles?.placeholder,
            }),
          }}
          isClearable={isClearable}
          {...props}
        />
      </div>
      {errorMessage && (
        <div className={classes.errorMessage}>{errorMessage}</div>
      )}
    </div>
  );
};

export default TextFieldSelectView;
